export default __webpack_public_path__ + "media/svgs/globe-6819e08e.svg";